var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-tabs",
            {
              staticClass: "flex-nowrap",
              staticStyle: { "min-height": "1000px" },
              attrs: {
                pills: "",
                card: "",
                vertical: "",
                "content-class": "scroll-extra",
              },
              model: {
                value: _vm.selected_tab,
                callback: function ($$v) {
                  _vm.selected_tab = $$v
                },
                expression: "selected_tab",
              },
            },
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    active: _vm.selected_tab === _vm.TABS.PLOT,
                    title: "GWAS",
                  },
                },
                [
                  _vm.has_studies
                    ? _c("lz-plot", {
                        ref: "assoc_plot",
                        attrs: {
                          show_loading: true,
                          base_layout: _vm.base_layout,
                          base_sources: _vm.base_sources,
                          chr: _vm.chr,
                          start: _vm.start,
                          end: _vm.end,
                          dynamic_urls: _vm.dynamic_urls,
                        },
                        on: {
                          element_clicked: _vm.onVariantClick,
                          connected: _vm.receivePlot,
                        },
                      })
                    : _c(
                        "div",
                        {
                          staticClass: "placeholder-plot",
                          staticStyle: { display: "table" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text-center",
                              staticStyle: {
                                display: "table-cell",
                                "vertical-align": "middle",
                              },
                            },
                            [
                              _vm._v(
                                "\n            Please add data from a tabix file to continue\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    active: _vm.selected_tab === _vm.TABS.PHEWAS,
                    disabled: !_vm.has_studies || !_vm.allow_phewas,
                  },
                },
                [
                  _c("template", { slot: "title" }, [
                    _c(
                      "span",
                      {
                        attrs: {
                          title: "Only available for build GRCh37 datasets",
                        },
                      },
                      [_vm._v("PheWAS")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("phewas-maker", {
                    ref: "phewas",
                    attrs: {
                      variant_name: _vm.tmp_phewas_variant,
                      genome_build: _vm.genome_build,
                      your_study: _vm.tmp_phewas_study,
                      your_logpvalue: _vm.tmp_phewas_logpvalue,
                      allow_render: _vm.selected_tab === _vm.TABS.PHEWAS,
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    active: _vm.selected_tab === _vm.TABS.EXPORT,
                    disabled: !_vm.has_studies,
                    title: "Export",
                  },
                },
                [
                  _c("export-data", {
                    attrs: {
                      known_tracks: _vm.known_tracks,
                      table_data: _vm.table_data,
                    },
                    on: { "requested-data": _vm.subscribeToData },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }